import { Alert, Button, Checkbox, FormControlLabel, FormGroup, Grid2, Snackbar } from "@mui/material";
import { useEffect, useState } from "react";
import axios from "axios";
import ReplyRoundedIcon from "@mui/icons-material/ReplyRounded";
import { Box, Fab } from "@mui/material";

function AdminSmileTrips() {
    const [servicos, setServicos] = useState([]);
    const [errorText, setErrorText] = useState('');
    const [successText, setSuccessText] = useState('');
    const [error, setError] = useState(false);
    const [open, setOpen] = useState(false);

    const handleCancel = async () => {
        await fetchServicos();
    };
    
    const handleToggleServicos = (id) => {
        setServicos((prev) =>
        prev.map((servico) =>
            servico.id === id
            ? { ...servico, smile_trips: servico.smile_trips === "S" ? "N" : "S" }
            : servico
        )
        );
    };

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setError(false);
        setOpen(false);
    };

    const fetchServicos = async () => {
        try {
        const response = await axios.get(`https://api.sigmasystems.com.br/api/odontoluzzi/get-servicos`);
        if (Array.isArray(response.data)) {
            const sorted = [...response.data].sort((a, b) => a.name.localeCompare(b.name));
            setServicos(sorted);
        }
        
        } catch (error) {
        console.error("Erro na requisição:", error);
        }
    };

    useEffect(() => {
        fetchServicos();
    }, []);

    const handleSave = async () => {
        try {
          const updates = servicos.map((s) => ({ id: s.id, smile_trips: s.smile_trips }));
          await axios.post("https://api.sigmasystems.com.br/api/odontoluzzi/update-smileTrips", { updates }, {headers:{"Content-Type":"application/json"}});
    
          setOpen(true);
          setSuccessText("Alterações salvas com sucesso!");
          await fetchServicos();
        } catch (err) {
          console.error(err);
          setError(true);
          setErrorText("Erro ao salvar alterações!");
        }
    };

    return(
        <div className="container">
            <div className="body" style={{ justifyItems: "center", width: "100%" }}>
                <div className="adminMenuContainer">
                    <div className="adminTitle">Smile-Trips</div>
                    <div
                        className="adminMenuContent"
                        style={{
                        maxWidth: "1280px",
                        height: "fit-content",
                        maxHeight:'700px',
                        borderRadius: "0px 0px 10px 10px",
                        }}
                    >
                        <div className="adminSubTitle">Lista de Serviços</div>
                        <Grid2 container spacing={2} sx={{marginTop:2}}>
                            <FormGroup row>                 
                                {servicos.map((servico) => (
                                <Grid2 item key={servico.id}>
                                    <FormControlLabel control={<Checkbox sx={{'&.Mui-checked':{color:'#B08E44'}}} checked={servico.smile_trips === "S"} onChange={() => handleToggleServicos(servico.id)}/>} label={servico?.name}/>
                                </Grid2>
                                ))} 
                                
                            </FormGroup>
                        </Grid2>
                        <Grid2 container spacing={2} sx={{ marginTop: 2 }}>
                            <Grid2 item>
                                <Button
                                variant="contained"
                                sx={{
                                    backgroundColor: "#B08E44",
                                    "&:hover": { backgroundColor: "#041819" },
                                }}
                                onClick={handleSave}
                                >
                                Finalizar
                                </Button>
                            </Grid2>
                            <Grid2 item>
                                <Button
                                variant="outlined"
                                sx={{ border: "2px solid #B08E44", color: "#B08E44" }}
                                onClick={handleCancel}
                                >
                                Cancelar
                                </Button>
                            </Grid2>
                        </Grid2>
                    </div>
                </div>
                <Box
            sx={{
              "& > :not(style)": { m: 1 },
              position: "absolute",
              bottom: 16,
              right: 16,
            }}
          >
            <Fab
              onClick={() => window.history.back()}
              variant="extended"
              sx={{
                backgroundColor: "#B08E44",
                color: "#fff",
                "&:hover": { backgroundColor: "#041819" },
              }}
            >
              <ReplyRoundedIcon sx={{ mr: 1 }} /> Voltar
            </Fab>
          </Box>
            </div>
            <Snackbar open={open} autoHideDuration={6000} onClose={handleClose} anchorOrigin={{vertical:'bottom',horizontal:'right'}}>
                <Alert
                onClose={handleClose}
                severity="success"
                variant="filled"
                sx={{ width: '100%' }}
                >
                {successText}
                </Alert>
            </Snackbar>
            <Snackbar open={error} autoHideDuration={6000} onClose={handleClose} anchorOrigin={{vertical:'bottom',horizontal:'right'}}>
                <Alert
                onClose={handleClose}
                severity="error"
                variant="filled"
                sx={{ width: '100%' }}
                >
                {errorText}
                </Alert>
            </Snackbar>
        </div>
    )
}
export default AdminSmileTrips;